import type { MeResponse } from "../../api/types";
import { ChangeEmailSection } from "./ChangeEmailSection";
import { ChangePasswordSection } from "./ChangePasswordSection";
import { MyDetailsSection } from "./MyDetailsSection";

/**
 * G-145 — what the profile's pencil opens: one card with My details, the
 * sign-in email and the password (owner 2026-10-13: two loose cards for email
 * and password "feels bad"; mockup claude.ai/artifact/1TrNtG7VoLaM4moWGsFRDa).
 *
 * Couriers do not self-edit name and phone (their own plane; the contact
 * endpoint is closed to them), so for them the panel holds email and password
 * only — which they could always change, and still must be able to.
 */
export function EditProfilePanel({
  me,
  canEditDetails,
  onDetailsSaved,
  onEmailChanged,
  onClose,
}: {
  me: MeResponse;
  canEditDetails: boolean;
  onDetailsSaved: () => Promise<void>;
  onEmailChanged: () => Promise<void>;
  onClose: () => void;
}) {
  return (
    <section className="card profile-edit" aria-label="Edit my profile">
      <div className="profile-edit-head">
        <h2>Edit my profile</h2>
        <button type="button" className="button tinted" onClick={onClose}>
          Done
        </button>
      </div>
      {canEditDetails ? <MyDetailsSection me={me} onSaved={onDetailsSaved} /> : null}
      <ChangeEmailSection me={me} onChanged={onEmailChanged} />
      <ChangePasswordSection />
    </section>
  );
}
